// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/admin.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddSubscriptionOverrideRequest, AddSubscriptionOverrideResponse, AdminCreateWorkspaceRequest, AdminUpdateWorkspaceRequest, AdminWorkspace, CancelSubscriptionRequest, CancelSubscriptionResponse, ChargeInvoiceRequest, ChargeInvoiceResponse, CreateBillingPlanRequest, CreateBillingPlanResponse, CreateFeatureRequest, CreateFeatureResponse, CreateSubscriptionRequest, CreateSubscriptionResponse, FinalizeInvoiceRequest, FinalizeInvoiceResponse, GenerateInviteLinkRequest, GenerateInviteLinkResponse, GenerateInvoiceRequest, GenerateInvoiceResponse, GetBillingPlanRequest, GetBillingPlanResponse, GetInvoiceRequest, GetInvoiceResponse, GetUsageMetricsRequest, GetUsageMetricsResponse, GetWorkspaceDetailsRequest, GetWorkspaceDetailsResponse, GetWorkspaceEntitlementsRequest, GetWorkspaceEntitlementsResponse, GetWorkspaceFeaturesRequest, GetWorkspaceFeaturesResponse, GetWorkspaceSubscriptionRequest, GetWorkspaceSubscriptionResponse, GetWorkspaceUsageRequest, GetWorkspaceUsageResponse, ImpersonateRequest, ImpersonateResponse, LinkPluginToFeatureRequest, LinkPluginToFeatureResponse, ListAllUsersRequest, ListAllUsersResponse, ListAllWorkspacesRequest, ListAllWorkspacesResponse, ListAuditLogRequest, ListAuditLogResponse, ListBillingMetricsRequest, ListBillingMetricsResponse, ListBillingPlansRequest, ListBillingPlansResponse, ListFeaturesRequest, ListFeaturesResponse, ListInvoicesRequest, ListInvoicesResponse, ReactivateWorkspaceRequest, RecordPaymentRequest, RecordPaymentResponse, RemovePlanGrantRequest, RemovePlanGrantResponse, RemoveSubscriptionOverrideRequest, RemoveSubscriptionOverrideResponse, SetBillingPaymentMethodRequest, SetBillingPaymentMethodResponse, SetPlanGrantRequest, SetPlanGrantResponse, SetPlanPriceRequest, SetPlanPriceResponse, SetWorkspaceFeatureRequest, SetWorkspaceFeatureResponse, SuspendWorkspaceRequest, UnlinkPluginFromFeatureRequest, UnlinkPluginFromFeatureResponse, UpdateBillingPlanRequest, UpdateBillingPlanResponse, UpdateSubscriptionRequest, UpdateSubscriptionResponse, VoidInvoiceRequest, VoidInvoiceResponse } from "./admin_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
import { EvalRun, ListAllEvalRunsRequest, ListAllEvalRunsResponse, StartCrossWorkspaceEvalRunRequest } from "./eval_pb.js";

/**
 * AdminService provides platform-wide administration capabilities
 *
 * @generated from service omnios.v1.AdminService
 */
export const AdminService = {
  typeName: "omnios.v1.AdminService",
  methods: {
    /**
     * Workspace management
     *
     * @generated from rpc omnios.v1.AdminService.ListAllWorkspaces
     */
    listAllWorkspaces: {
      name: "ListAllWorkspaces",
      I: ListAllWorkspacesRequest,
      O: ListAllWorkspacesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.GetWorkspaceDetails
     */
    getWorkspaceDetails: {
      name: "GetWorkspaceDetails",
      I: GetWorkspaceDetailsRequest,
      O: GetWorkspaceDetailsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.CreateWorkspace
     */
    createWorkspace: {
      name: "CreateWorkspace",
      I: AdminCreateWorkspaceRequest,
      O: AdminWorkspace,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.UpdateWorkspace
     */
    updateWorkspace: {
      name: "UpdateWorkspace",
      I: AdminUpdateWorkspaceRequest,
      O: AdminWorkspace,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.SuspendWorkspace
     */
    suspendWorkspace: {
      name: "SuspendWorkspace",
      I: SuspendWorkspaceRequest,
      O: AdminWorkspace,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.ReactivateWorkspace
     */
    reactivateWorkspace: {
      name: "ReactivateWorkspace",
      I: ReactivateWorkspaceRequest,
      O: AdminWorkspace,
      kind: MethodKind.Unary,
    },
    /**
     * User management
     *
     * @generated from rpc omnios.v1.AdminService.ListAllUsers
     */
    listAllUsers: {
      name: "ListAllUsers",
      I: ListAllUsersRequest,
      O: ListAllUsersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Analytics
     *
     * @generated from rpc omnios.v1.AdminService.GetUsageMetrics
     */
    getUsageMetrics: {
      name: "GetUsageMetrics",
      I: GetUsageMetricsRequest,
      O: GetUsageMetricsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Onboarding
     *
     * @generated from rpc omnios.v1.AdminService.GenerateInviteLink
     */
    generateInviteLink: {
      name: "GenerateInviteLink",
      I: GenerateInviteLinkRequest,
      O: GenerateInviteLinkResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Audit
     *
     * @generated from rpc omnios.v1.AdminService.ListAuditLog
     */
    listAuditLog: {
      name: "ListAuditLog",
      I: ListAuditLogRequest,
      O: ListAuditLogResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Impersonation
     *
     * @generated from rpc omnios.v1.AdminService.Impersonate
     */
    impersonate: {
      name: "Impersonate",
      I: ImpersonateRequest,
      O: ImpersonateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Eval (cross-workspace)
     *
     * @generated from rpc omnios.v1.AdminService.StartCrossWorkspaceEvalRun
     */
    startCrossWorkspaceEvalRun: {
      name: "StartCrossWorkspaceEvalRun",
      I: StartCrossWorkspaceEvalRunRequest,
      O: EvalRun,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.ListAllEvalRuns
     */
    listAllEvalRuns: {
      name: "ListAllEvalRuns",
      I: ListAllEvalRunsRequest,
      O: ListAllEvalRunsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Feature management
     *
     * @generated from rpc omnios.v1.AdminService.ListFeatures
     */
    listFeatures: {
      name: "ListFeatures",
      I: ListFeaturesRequest,
      O: ListFeaturesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.GetWorkspaceFeatures
     */
    getWorkspaceFeatures: {
      name: "GetWorkspaceFeatures",
      I: GetWorkspaceFeaturesRequest,
      O: GetWorkspaceFeaturesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.SetWorkspaceFeature
     */
    setWorkspaceFeature: {
      name: "SetWorkspaceFeature",
      I: SetWorkspaceFeatureRequest,
      O: SetWorkspaceFeatureResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.CreateFeature
     */
    createFeature: {
      name: "CreateFeature",
      I: CreateFeatureRequest,
      O: CreateFeatureResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.LinkPluginToFeature
     */
    linkPluginToFeature: {
      name: "LinkPluginToFeature",
      I: LinkPluginToFeatureRequest,
      O: LinkPluginToFeatureResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.UnlinkPluginFromFeature
     */
    unlinkPluginFromFeature: {
      name: "UnlinkPluginFromFeature",
      I: UnlinkPluginFromFeatureRequest,
      O: UnlinkPluginFromFeatureResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Billing - Subscriptions
     *
     * @generated from rpc omnios.v1.AdminService.GetWorkspaceSubscription
     */
    getWorkspaceSubscription: {
      name: "GetWorkspaceSubscription",
      I: GetWorkspaceSubscriptionRequest,
      O: GetWorkspaceSubscriptionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.CreateSubscription
     */
    createSubscription: {
      name: "CreateSubscription",
      I: CreateSubscriptionRequest,
      O: CreateSubscriptionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.UpdateSubscription
     */
    updateSubscription: {
      name: "UpdateSubscription",
      I: UpdateSubscriptionRequest,
      O: UpdateSubscriptionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.CancelSubscription
     */
    cancelSubscription: {
      name: "CancelSubscription",
      I: CancelSubscriptionRequest,
      O: CancelSubscriptionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Billing - Overrides
     *
     * @generated from rpc omnios.v1.AdminService.AddSubscriptionOverride
     */
    addSubscriptionOverride: {
      name: "AddSubscriptionOverride",
      I: AddSubscriptionOverrideRequest,
      O: AddSubscriptionOverrideResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.RemoveSubscriptionOverride
     */
    removeSubscriptionOverride: {
      name: "RemoveSubscriptionOverride",
      I: RemoveSubscriptionOverrideRequest,
      O: RemoveSubscriptionOverrideResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Billing - Invoices
     *
     * @generated from rpc omnios.v1.AdminService.ListInvoices
     */
    listInvoices: {
      name: "ListInvoices",
      I: ListInvoicesRequest,
      O: ListInvoicesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.GetInvoice
     */
    getInvoice: {
      name: "GetInvoice",
      I: GetInvoiceRequest,
      O: GetInvoiceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.GenerateInvoice
     */
    generateInvoice: {
      name: "GenerateInvoice",
      I: GenerateInvoiceRequest,
      O: GenerateInvoiceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.FinalizeInvoice
     */
    finalizeInvoice: {
      name: "FinalizeInvoice",
      I: FinalizeInvoiceRequest,
      O: FinalizeInvoiceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.RecordPayment
     */
    recordPayment: {
      name: "RecordPayment",
      I: RecordPaymentRequest,
      O: RecordPaymentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.ChargeInvoice
     */
    chargeInvoice: {
      name: "ChargeInvoice",
      I: ChargeInvoiceRequest,
      O: ChargeInvoiceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.VoidInvoice
     */
    voidInvoice: {
      name: "VoidInvoice",
      I: VoidInvoiceRequest,
      O: VoidInvoiceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.SetBillingPaymentMethod
     */
    setBillingPaymentMethod: {
      name: "SetBillingPaymentMethod",
      I: SetBillingPaymentMethodRequest,
      O: SetBillingPaymentMethodResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Billing - Usage & Entitlements
     *
     * @generated from rpc omnios.v1.AdminService.GetWorkspaceUsage
     */
    getWorkspaceUsage: {
      name: "GetWorkspaceUsage",
      I: GetWorkspaceUsageRequest,
      O: GetWorkspaceUsageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.GetWorkspaceEntitlements
     */
    getWorkspaceEntitlements: {
      name: "GetWorkspaceEntitlements",
      I: GetWorkspaceEntitlementsRequest,
      O: GetWorkspaceEntitlementsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Billing - Plans
     *
     * @generated from rpc omnios.v1.AdminService.ListBillingPlans
     */
    listBillingPlans: {
      name: "ListBillingPlans",
      I: ListBillingPlansRequest,
      O: ListBillingPlansResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.CreateBillingPlan
     */
    createBillingPlan: {
      name: "CreateBillingPlan",
      I: CreateBillingPlanRequest,
      O: CreateBillingPlanResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.UpdateBillingPlan
     */
    updateBillingPlan: {
      name: "UpdateBillingPlan",
      I: UpdateBillingPlanRequest,
      O: UpdateBillingPlanResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.GetBillingPlan
     */
    getBillingPlan: {
      name: "GetBillingPlan",
      I: GetBillingPlanRequest,
      O: GetBillingPlanResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Billing - Plan Grants & Pricing
     *
     * @generated from rpc omnios.v1.AdminService.SetPlanGrant
     */
    setPlanGrant: {
      name: "SetPlanGrant",
      I: SetPlanGrantRequest,
      O: SetPlanGrantResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.RemovePlanGrant
     */
    removePlanGrant: {
      name: "RemovePlanGrant",
      I: RemovePlanGrantRequest,
      O: RemovePlanGrantResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.SetPlanPrice
     */
    setPlanPrice: {
      name: "SetPlanPrice",
      I: SetPlanPriceRequest,
      O: SetPlanPriceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdminService.ListBillingMetrics
     */
    listBillingMetrics: {
      name: "ListBillingMetrics",
      I: ListBillingMetricsRequest,
      O: ListBillingMetricsResponse,
      kind: MethodKind.Unary,
    },
  }
};

